<template>
  <v-container >
    <entity-properties-row :label="$t('plannedService.name')"
                           :property="plannedService.name"/>

    <entity-properties-row :label="$t('plannedService.device')"
                           :property="plannedService.device | device"/>

    <entity-properties-row :label="$t('plannedService.priority')"
                           :property="plannedService.priority | priority"/>

    <entity-properties-row v-if="!isRepeating"
                           :label="$t('plannedService.scheduleDate')"
                           :property="plannedService.startDate | date"/>

    <entity-properties-row v-if="isRepeating"
                           :label="$t('plannedService.repeatStartDate')"
                           :property="plannedService.startDate | date"/>

    <entity-properties-row v-if="isRepeating"
                           :label="$t('plannedService.repeatEndDate')"
                           :property="plannedService.repeatEndDate | date"/>

    <entity-properties-row v-if="isRepeating"
                           :label="$t('plannedService.repetition')"
                           :property="repetition"/>

    <entity-properties-row :label="$t('plannedService.duration')"
                           :property="plannedService.durationMinutes | duration"/>

    <entity-properties-row :label="$t('plannedService.description')">
      <preformatted-text-view :value="plannedService.description"/>
    </entity-properties-row>

    <entity-properties-row :label="$t('plannedService.requiredParts')">
      <plain-unordered-list :items="requiredParts"/>
    </entity-properties-row>

    <entity-properties-row :label="$t('plannedService.serviceManagers')">
      <plain-unordered-list :items="serviceManagers"/>
    </entity-properties-row>

    <entity-properties-row :label="$t('plannedService.authorUsers')">
      <plain-unordered-list :items="authorUsers"/>
    </entity-properties-row>

    <entity-properties-row :label="$t('plannedService.documents')">
      <document-list :documents="documents"/>
    </entity-properties-row>

    <slot name="append"></slot>
  </v-container>
</template>

<script>
import i18n from '@/i18n';
import DocumentList from '@/components/layouts/DocumentList';
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import PreformattedTextView from '@/components/layouts/PreformattedTextView';
import PlainUnorderedList from '@/components/layouts/PlainUnorderedList';

export default {
  name: 'PlannedServicePropertiesView',
  components: { PlainUnorderedList, PreformattedTextView, EntityPropertiesRow, DocumentList },
  props:{
    plannedService: {
      required:true,
      type: Object,
    },
    documents: {
      required:true,
      type: Array,
    },
  },
  computed: {

    isRepeating() {
      return this.plannedService?.repeatEndDate != null;
    },

    repetition() {
      if (!this.isRepeating) {
        return null;
      }
      return this.plannedService.repeatCount + ' ' +
          i18n.t('plannedService.repeatType' + this.plannedService.repeatType);
    },

    requiredParts() {
      if (!this.plannedService) {
        return [];
      }
      return this.plannedService.requiredParts.map(partQuantity => this.$options.filters.partQuantity(partQuantity));
    },
    serviceManagers() {
      if (!this.plannedService) {
        return [];
      }
      return this.plannedService.serviceManagers.map(user => this.$options.filters.user(user));
    },
    authorUsers() {
      if (!this.plannedService) {
        return [];
      }
      return this.plannedService.authorUsers.map(user => this.$options.filters.user(user));
    },
  },
};
</script>

<style scoped>

</style>
